import { Link } from "react-router-dom";

// Bandeau légal minimal — présent sur TOUTES les pages hors site public
// (administration, espace utilisateur, ambassadeurs, partenaires…).
// Les pages publiques affichent déjà cette ligne dans le pied de page complet
// (components/Footer.jsx). Toute future page doit passer par l'un des layouts
// (PublicLayout / AdminLayout / AppLayout) ou être enveloppée de `withLegal` (App.js).
export default function LegalStrip() {
  return (
    <div className="border-t border-white/10 bg-void px-5 py-4" data-testid="legal-strip">
      <span className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-ink-tertiary">
        <span>© {new Date().getFullYear()} APP CHALLENGE ACADEMY — appchallengeacademy.com</span>
        <span className="text-white/20">·</span>
        <Link to="/cgu" className="underline-offset-2 transition-colors hover:text-cyan hover:underline" data-testid="legal-strip-cgu">CGU</Link>
        <span className="text-white/20">·</span>
        <Link to="/mentions-legales" className="underline-offset-2 transition-colors hover:text-cyan hover:underline" data-testid="legal-strip-ml">Mentions légales</Link>
      </span>
    </div>
  );
}
